import React from 'react'
import AccordionWithImage from '../../../shared/BrandPages/AccordionWithImage'
import ColumnToRowSection from '../../../shared/BrandPages/ColumnToRowSection'
import BottomSection from '../../../shared/BrandPages/BottomSection'
import AsFeaturedIn from '../../../shared/BrandPages/AsFeaturedIn'
import HeroSection from '../../../shared//Rewrite/BrandPages/HeroSection'
import BrandSection from '../../../shared/BrandPages/BrandSection'
import VideoPlayer from 'src/components/shared/VideoPlayer'
import RecommendedReads from '../../../shared/BrandPages/RecommendedReads'
import { whyWereBetterData } from './consts'
import Section from '../../../shared/BrandPages/Section'
import Content from '../../../shared/BrandPages/Content'
import styles from './index.module.scss'
import { jsonLdData } from '../../../../common/constants/jsonLd'
import CustomJsonLd from '../../../shared/CustomJsonLd'
import WithSeoOverrides from 'src/components/shared/WithSeoOverride'

const WhyWereBetterPage = () => {
  const {
    heroData,
    brandDataClientReviews,
    accordionWithImgData,
    brandDataPromises,
    columnToRow,
    brandDataClientTestimonials,
    testimonialsVideoData,
    featuredInData,
    recommendedReadsData,
    bottomSectionData,
    seo,
  } = whyWereBetterData

  return (
    <Content>
      <WithSeoOverrides {...seo} />
      <CustomJsonLd
        id={'webPage'}
        data={jsonLdData(seo?.title, seo?.description, '/why-were-better/')}
      />
      <Section classNames="pt-0 pb-0 lg:pl-4 xl:pl-0">
        <HeroSection
          {...heroData}
          showMobileFirst={false}
          contentClassName={styles.contentClassName}
          heroContainerClassName={styles.heroClassName}
          overlayShadowClassName={styles.overlayShadow}
        />
      </Section>
      <Section classNames={'bg-blue-base-white'}>
        <BrandSection
          {...brandDataClientReviews}
          childClassName="order-4 pt-10 pb-8"
          primaryBtnClassName="px-9 bg-red-950"
        >
          <AccordionWithImage faqs={accordionWithImgData} />
        </BrandSection>
      </Section>
      <Section>
        <BrandSection
          {...brandDataPromises}
          childClassName="order-3 px-11 lg:px-0 lg:pt-19 pt-8"
        >
          <ColumnToRowSection data={columnToRow} />
        </BrandSection>
      </Section>
      <Section classNames="bg-blue-base-white">
        <BrandSection
          {...brandDataClientTestimonials}
          childClassName="order-last pb-3 pt-8 lg:pb-0 flex items-center justify-center mx-4"
        >
          <div id="video-player">
            <VideoPlayer
              thumbnail="rounded-full h-12 w-12 md:h-20 md:w-20 bg-gray-230"
              url={testimonialsVideoData.videoLink}
              light={testimonialsVideoData.videoImg}
              className={`h-52 w-[21rem] md:h-72 md:w-[32.5rem] lg:h-96 lg:w-[50rem] xl:h-[28rem]`}
            />
          </div>
        </BrandSection>
      </Section>
      <Section>
        <AsFeaturedIn items={featuredInData} />
      </Section>
      <Section classNames="bg-blue-base-white">
        <RecommendedReads data={recommendedReadsData} />
      </Section>
      <Section classNames="pb-0 pt-0">
        <BottomSection {...bottomSectionData} />
      </Section>
    </Content>
  )
}

export default WhyWereBetterPage
